import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import css from './TicketExpiration.module.scss';

interface Props {
  className?: string;
  expiration: number;
}

const TicketExpiration = (props: Props & InjectedIntlProps) => {
  return (
    <span className={classNames(css.TicketExpiration, props.className)}>
      <span className={css.TicketExpiration__Emphasis}>{props.expiration}</span>
      {props.intl.formatMessage({
        id: 'merchants.common.ticketExpiration.unit',
      })}
    </span>
  );
};

export default injectIntl(TicketExpiration);
